import React, { useState, useEffect, useCallback, useMemo } from 'react';
import './Hero.css';
import { Link } from 'react-router-dom';

// Import your images
import heroBanner1 from '../Assets/landing-banner.jpg';
import heroBanner2 from '../Assets/heroBanner.png';
import arrow from '../Assets/arrowP.png';

const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  const slides = useMemo(() => [
    {
      image: heroBanner1,
      title: "Premium Livestock",
      subtitle: "Healthy animals for your farm"
    },
    {
      image: heroBanner2,
      title: "Dairy Excellence",
      subtitle: "High-quality dairy cattle"
    },
  ], []);

  const nextSlide = useCallback(() => {
    setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
  }, [slides.length]);

  const prevSlide = useCallback(() => {
    setCurrentSlide((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
  }, [slides.length]);

  const goToSlide = useCallback((index) => {
    setCurrentSlide(index);
  }, []);

  useEffect(() => {
    let interval;
    if (isAutoPlaying) {
      interval = setInterval(() => {
        nextSlide();
      }, 5000);
    }
    return () => clearInterval(interval);
  }, [currentSlide, isAutoPlaying, nextSlide]);
  return (
    <div className="hero-container">
      {/* Carousel */}
      <div 
        className="carousel"
        onMouseEnter={() => setIsAutoPlaying(false)}
        onMouseLeave={() => setIsAutoPlaying(true)}
      >
        {/* Slides */}
        <div 
          className="slides-container"
          style={{ transform: `translateX(-${currentSlide * 100}%)` }}
        >
          {slides.map((slide, index) => (
            <div 
              key={index}
              className={`slide ${index === currentSlide ? 'active' : ''}`}
              style={{ backgroundImage: `url(${slide.image})` }}
            >
              <div className="slide-overlay"></div>
              <div className="slide-content">
                <h2>{slide.title}</h2>
                <p>{slide.subtitle}</p>
                <Link to="/" className="shop-now-btn">
                  SHOP NOW <img src={arrow} alt="arrow" />
                </Link>
              </div>
            </div>
          ))}
        </div>

        {/* Navigation Arrows */}
        <button className="carousel-arrow prev" onClick={prevSlide}>
          &lt;
        </button>
        <button className="carousel-arrow next" onClick={nextSlide}>
          &gt;
        </button>

        {/* Indicators */}
        <div className="indicators">
          {slides.map((_, index) => (
            <button
              key={index}
              className={`indicator ${index === currentSlide ? 'active' : ''}`}
              onClick={() => goToSlide(index)}
            />
          ))}
        </div>
      </div>

    </div>
  );
};

export default Hero;